import {ObjectDTO} from "./object-dto";

export class AllergeneDTO  extends ObjectDTO{

  // allergene
  code: string;
  libelle: string;
  libellelong:string;
  actif:boolean;

}
